import { apiFetch } from './api'
import type { CustomerListItem, CustomerDetail } from './customer-types'

/**
 * Envelope the runtime bridge wraps customer responses in. `source` is
 * 'unavailable' (with empty/null data) when the product API can't be reached,
 * so the UI can distinguish "bridge down" from "no data".
 */
export interface CustomerBridgeResponse<T> {
  data: T
  source: 'tmagent-api' | 'unavailable'
  message?: string
}

/** Read-only customer endpoints, proxied through the runtime bridge. */
export const customersApi = {
  list: () =>
    apiFetch<CustomerBridgeResponse<CustomerListItem[]>>('/api/bridge/customers'),

  detail: (tenantId: string) =>
    apiFetch<CustomerBridgeResponse<CustomerDetail | null>>(
      `/api/bridge/customers/${encodeURIComponent(tenantId)}`,
    ),
}
